import settingPos from './setting_pos'
import settingMonitor from './setting_monitor'
import settingQueueSound from './setting_queue_sound'

export default {
  settingPos,
  settingMonitor,
  settingQueueSound
}



// WEBPACK FOOTER //
// ./src/components/BeFood/index.js